import { recordJourney } from './journey';

// Camada de dados (dataLayer) para o Google Tag Manager.
//
// track() empurra eventos para window.dataLayer de forma segura: se o GTM não
// estiver carregado (ex.: dev local, ou REACT_APP_GTM_ID não configurado no CI),
// vira um no-op inofensivo — os eventos só ficam acumulados no array.
//
// IMPORTANTE (LGPD): nunca envie PII (nome, telefone, e-mail) para o dataLayer.
// Use apenas flags/contadores/labels não-identificáveis.
export function track(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  // GA4 direto (gtag): encaminha o evento como GA4 event.
  if (typeof window.gtag === 'function') window.gtag('event', event, params);
  // Jornada do visitante (fica só no navegador até o lead — ver journey.js).
  recordJourney(event, params);
}
